import React from "react";
import { useTranslation } from "react-i18next";

const MobileCalendarPreview = (props) => {
  const { t } = useTranslation("dashboard");
  const { brandingColor, theme, isDefaultColor, secondaryTextColor } = props;

  const primaryColor =
    brandingColor && !isDefaultColor ? brandingColor : "#5BC500";
  const bgColor = theme === "light" ? "#F2F2F2" : "#181818";
  const elevationOne =
    theme === "light" ? "#FFFFFF" : "rgba(255, 255, 255, 0.05)";
  const elevationTwo =
    theme === "light" ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.1)";
  const textHigh =
    theme === "light" ? "rgba(0, 0, 0, 0.87)" : "rgba(255, 255, 255, 0.87)";
  const textMid =
    theme === "light" ? "rgba(0, 0, 0, 0.6)" : "rgba(255, 255, 255, 0.6)";
  const textLow =
    theme === "light" ? "rgba(0, 0, 0, 0.38)" : "rgba(255, 255, 255, 0.38)";
  const textColor = secondaryTextColor || "#FFFFFF";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="360"
      height="760"
      viewBox="0 0 360 760"
    >
      <defs>
        <filter
          id="MENU_copy_84"
          width="120"
          height="120"
          x="-32.001"
          y="356.125"
          filterUnits="userSpaceOnUse"
        >
          <feOffset></feOffset>
          <feGaussianBlur result="blur" stdDeviation="16"></feGaussianBlur>
          <feFlood floodOpacity="0.141"></feFlood>
          <feComposite in2="blur" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
        <filter
          id="MENU_copy_84-2"
          width="120"
          height="120"
          x="-32.001"
          y="629.125"
          filterUnits="userSpaceOnUse"
        >
          <feOffset></feOffset>
          <feGaussianBlur result="blur-2" stdDeviation="16"></feGaussianBlur>
          <feFlood floodOpacity="0.141"></feFlood>
          <feComposite in2="blur-2" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
        <filter
          id="MENU_copy_3"
          width="419"
          height="98"
          x="-27"
          y="256"
          filterUnits="userSpaceOnUse"
        >
          <feOffset></feOffset>
          <feGaussianBlur result="blur-3" stdDeviation="16"></feGaussianBlur>
          <feFlood floodOpacity="0.141"></feFlood>
          <feComposite in2="blur-3" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
        <filter
          id="MENU_copy_4"
          width="316"
          height="98"
          x="-32"
          y="256"
          filterUnits="userSpaceOnUse"
        >
          <feOffset></feOffset>
          <feGaussianBlur result="blur-4" stdDeviation="16"></feGaussianBlur>
          <feFlood floodOpacity="0.141"></feFlood>
          <feComposite in2="blur-4" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
        <filter
          id="Rectangle_903"
          width="411"
          height="131"
          x="-25.5"
          y="644.5"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="-10"></feOffset>
          <feGaussianBlur result="blur-5" stdDeviation="8.5"></feGaussianBlur>
          <feFlood floodOpacity="0.659"></feFlood>
          <feComposite in2="blur-5" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
        <clipPath id="clip-Calendar_Dark">
          <path d="M0 0H360V760H0z"></path>
        </clipPath>
      </defs>
      <g clipPath="url(#clip-Calendar_Dark)" data-name="Calendar Dark">
        <path fill={bgColor} d="M0 0H360V760H0z"></path>
        <g data-name="Group 3242" transform="translate(0 -47)">
          <rect
            width="344"
            height="265"
            fill={elevationOne}
            data-name="Rectangle 1058"
            rx="8"
            transform="translate(8 435)"
          ></rect>
          <g data-name="Group 481" transform="translate(-6 84)">
            <rect
              width="66"
              height="24"
              fill={elevationTwo}
              data-name="Rectangle 4 copy 35"
              rx="12"
              transform="translate(58 367)"
            ></rect>
            <text
              fill={textHigh}
              fontFamily="OpenSans-Bold, Open Sans"
              fontSize="12"
              fontWeight="700"
              transform="translate(73 384)"
            >
              <tspan x="0" y="0">
                {t("workout.bench")}
              </tspan>
            </text>
          </g>
          <g data-name="Group 474" transform="translate(-6.463 79)">
            <g filter="url(#MENU_copy_84)" transform="translate(6.46 -32)">
              <rect
                width="24"
                height="24"
                fill={primaryColor}
                data-name="MENU copy 84"
                rx="12"
                transform="translate(16 404.12)"
              ></rect>
            </g>
            <text
              fill={textColor}
              fontFamily="OpenSans-Bold, Open Sans"
              fontSize="12"
              fontWeight="700"
              transform="translate(30.462 388.443)"
            >
              <tspan x="0" y="0">
                A
              </tspan>
            </text>
          </g>
          <g data-name="Group 479" transform="translate(6 84)">
            <path
              fill={textHigh}
              d="M8 0a8 8 0 018 8 8 8 0 01-8 8 8 8 0 01-8-8 8 8 0 018-8z"
              data-name="MENU copy 84"
              transform="translate(322 372)"
            ></path>
          </g>
          <path
            d="M12.34 7.073a.536.536 0 00-.761 0l-3.994 4-1.678-1.684a.548.548 0 10-.761.788L7.2 12.236a.536.536 0 00.761 0l4.379-4.375a.536.536 0 000-.788z"
            transform="translate(327.021 454.086)"
          ></path>
          <path
            fill="#5bc500"
            d="M16.248 7.157a.821.821 0 00-1.165 0L8.968 13.28 6.4 10.7a.839.839 0 10-1.165 1.206l3.152 3.152a.821.821 0 001.165 0l6.7-6.7a.821.821 0 000-1.206z"
            data-name="check"
            transform="translate(94.488 544.937)"
          ></path>
          <path
            fill="#5bc500"
            d="M16.248 7.157a.821.821 0 00-1.165 0L8.968 13.28 6.4 10.7a.839.839 0 10-1.165 1.206l3.152 3.152a.821.821 0 001.165 0l6.7-6.7a.821.821 0 000-1.206z"
            data-name="check"
            transform="translate(94.488 624.937)"
          ></path>
          <path
            fill="#5bc500"
            d="M16.248 7.157a.821.821 0 00-1.165 0L8.968 13.28 6.4 10.7a.839.839 0 10-1.165 1.206l3.152 3.152a.821.821 0 001.165 0l6.7-6.7a.821.821 0 000-1.206z"
            data-name="check"
            transform="translate(94.488 644.341)"
          ></path>
          <path
            fill="#5bc500"
            d="M16.248 7.157a.821.821 0 00-1.165 0L8.968 13.28 6.4 10.7a.839.839 0 10-1.165 1.206l3.152 3.152a.821.821 0 001.165 0l6.7-6.7a.821.821 0 000-1.206z"
            data-name="check"
            transform="translate(94.488 663.745)"
          ></path>
          <text
            fill={textHigh}
            data-name="1 x 5 Reps @ RPE7"
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="12"
            fontWeight="700"
            transform="translate(97 508)"
          >
            <tspan x="-52.31" y="0">
              1 x 5 Reps @ RPE7
            </tspan>
          </text>
          <text
            fill={textHigh}
            data-name="3 x 5 Reps @ 142.5 kg (70%)"
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="12"
            fontWeight="700"
            transform="translate(125 588)"
          >
            <tspan x="-79.784" y="0">
              3 x 5 Reps @ 142.5 kg (70%)
            </tspan>
          </text>
          <text
            fill={primaryColor}
            data-name="Actual Results:"
            fontFamily="OpenSans, Open Sans"
            fontSize="10"
            transform="translate(77 539)"
          >
            <tspan x="-33.818" y="0">
              Actual Results:
            </tspan>
          </text>
          <text
            fill={primaryColor}
            data-name="Actual Results:"
            fontFamily="OpenSans, Open Sans"
            fontSize="10"
            transform="translate(77 619)"
          >
            <tspan x="-33.818" y="0">
              Actual Results:
            </tspan>
          </text>
          <circle
            cx="4"
            cy="4"
            r="4"
            fill={primaryColor}
            data-name="Ellipse 88"
            transform="translate(24 500)"
          ></circle>
          <circle
            cx="4"
            cy="4"
            r="4"
            fill={primaryColor}
            data-name="Ellipse 89"
            transform="translate(24 580)"
          ></circle>
          <path
            fill={elevationTwo}
            d="M0 0H320V1H0z"
            data-name="Rectangle 1059"
            transform="translate(24 519)"
          ></path>
          <path
            fill={elevationTwo}
            d="M0 0H320V1H0z"
            data-name="Rectangle 1060"
            transform="translate(24 599)"
          ></path>
          <text
            fill={textLow}
            data-name="1"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(145 561)"
          >
            <tspan x="-3.431" y="0">
              1
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="1"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(145 641)"
          >
            <tspan x="-3.431" y="0">
              1
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="2"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(145 660.404)"
          >
            <tspan x="-3.431" y="0">
              2
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="3"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(145 679.809)"
          >
            <tspan x="-3.431" y="0">
              3
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="5"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(195 561)"
          >
            <tspan x="-3.431" y="0">
              5
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="5"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(195 641)"
          >
            <tspan x="-3.431" y="0">
              5
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="5"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(195 660.404)"
          >
            <tspan x="-3.431" y="0">
              5
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="5"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(195 679.809)"
          >
            <tspan x="-3.431" y="0">
              5
            </tspan>
          </text>
          <text
            fill={textHigh}
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="12"
            fontWeight="700"
            transform="translate(192 540)"
          >
            <tspan x="-14.285" y="0">
              Reps
            </tspan>
          </text>
          <text
            fill={textHigh}
            data-name="Reps"
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="12"
            fontWeight="700"
            transform="translate(192 620)"
          >
            <tspan x="-14.285" y="0">
              Reps
            </tspan>
          </text>
          <text
            fill={textHigh}
            data-name="#"
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="12"
            fontWeight="700"
            transform="translate(145 540)"
          >
            <tspan x="-3.876" y="0">
              #
            </tspan>
          </text>
          <text
            fill={textHigh}
            data-name="#"
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="12"
            fontWeight="700"
            transform="translate(145 620)"
          >
            <tspan x="-3.876" y="0">
              #
            </tspan>
          </text>
          <text
            fill={textHigh}
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="12"
            fontWeight="700"
            transform="translate(247 540)"
          >
            <tspan x="-11.089" y="0">
              RPE
            </tspan>
          </text>
          <text
            fill={textHigh}
            data-name="RPE"
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="12"
            fontWeight="700"
            transform="translate(247 620)"
          >
            <tspan x="-11.089" y="0">
              RPE
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="7"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(244 561)"
          >
            <tspan x="-3.431" y="0">
              7
            </tspan>
          </text>
          <text
            fill={textHigh}
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="12"
            fontWeight="700"
            transform="translate(302 540)"
          >
            <tspan x="-14.525" y="0">
              Load
            </tspan>
          </text>
          <text
            fill={textHigh}
            data-name="Load"
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="12"
            fontWeight="700"
            transform="translate(302 620)"
          >
            <tspan x="-14.525" y="0">
              Load
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="160 kg"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(302 561)"
          >
            <tspan x="-18.287" y="0">
              160 kg
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="142.5 kg"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(302 641)"
          >
            <tspan x="-23.314" y="0">
              142.5 kg
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="142.5 kg"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(302 660.404)"
          >
            <tspan x="-23.314" y="0">
              142.5 kg
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="142.5 kg"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(302 679.809)"
          >
            <tspan x="-23.314" y="0">
              142.5 kg
            </tspan>
          </text>
          <g data-name="Group 1686" transform="translate(0 45)">
            <path
              fill={textMid}
              d="M12 10a2 2 0 102 2 2 2 0 00-2-2zm-7 0a2 2 0 102 2 2 2 0 00-2-2zm14 0a2 2 0 102 2 2 2 0 00-2-2z"
              transform="translate(295 408)"
            ></path>
          </g>
        </g>
        <g data-name="Group 7635" transform="translate(0 226)">
          <rect
            width="344"
            height="265"
            fill={elevationOne}
            data-name="Rectangle 1058"
            rx="8"
            transform="translate(8 435)"
          ></rect>
          <g data-name="Group 481" transform="translate(-6 84)">
            <rect
              width="66"
              height="24"
              fill={elevationTwo}
              data-name="Rectangle 4 copy 35"
              rx="12"
              transform="translate(58 367)"
            ></rect>
            <text
              fill={textHigh}
              data-name="Bench"
              fontFamily="OpenSans-Bold, Open Sans"
              fontSize="12"
              fontWeight="700"
              transform="translate(73 384)"
            >
              <tspan x="0" y="0">
                Bench
              </tspan>
            </text>
          </g>
          <g data-name="Group 474" transform="translate(-6.463 79)">
            <g filter="url(#MENU_copy_84-2)" transform="translate(6.46 -305)">
              <rect
                width="24"
                height="24"
                fill={primaryColor}
                data-name="MENU copy 84"
                rx="12"
                transform="translate(16 677.12)"
              ></rect>
            </g>
            <text
              fill={textColor}
              data-name="A"
              fontFamily="OpenSans-Bold, Open Sans"
              fontSize="12"
              fontWeight="700"
              transform="translate(30.462 388.443)"
            >
              <tspan x="0" y="0">
                A
              </tspan>
            </text>
          </g>
          <g data-name="Group 479" transform="translate(6 84)">
            <path
              fill={textHigh}
              d="M8 0a8 8 0 018 8 8 8 0 01-8 8 8 8 0 01-8-8 8 8 0 018-8z"
              data-name="MENU copy 84"
              transform="translate(322 372)"
            ></path>
          </g>
          <path
            d="M12.34 7.073a.536.536 0 00-.761 0l-3.994 4-1.678-1.684a.548.548 0 10-.761.788L7.2 12.236a.536.536 0 00.761 0l4.379-4.375a.536.536 0 000-.788z"
            data-name="check"
            transform="translate(327.021 454.086)"
          ></path>
          <path
            fill="#5bc500"
            d="M16.248 7.157a.821.821 0 00-1.165 0L8.968 13.28 6.4 10.7a.839.839 0 10-1.165 1.206l3.152 3.152a.821.821 0 001.165 0l6.7-6.7a.821.821 0 000-1.206z"
            data-name="check"
            transform="translate(94.488 544.937)"
          ></path>
          <path
            fill="#5bc500"
            d="M16.248 7.157a.821.821 0 00-1.165 0L8.968 13.28 6.4 10.7a.839.839 0 10-1.165 1.206l3.152 3.152a.821.821 0 001.165 0l6.7-6.7a.821.821 0 000-1.206z"
            data-name="check"
            transform="translate(94.488 624.937)"
          ></path>
          <path
            fill="#5bc500"
            d="M16.248 7.157a.821.821 0 00-1.165 0L8.968 13.28 6.4 10.7a.839.839 0 10-1.165 1.206l3.152 3.152a.821.821 0 001.165 0l6.7-6.7a.821.821 0 000-1.206z"
            data-name="check"
            transform="translate(94.488 644.341)"
          ></path>
          <path
            fill="#5bc500"
            d="M16.248 7.157a.821.821 0 00-1.165 0L8.968 13.28 6.4 10.7a.839.839 0 10-1.165 1.206l3.152 3.152a.821.821 0 001.165 0l6.7-6.7a.821.821 0 000-1.206z"
            data-name="check"
            transform="translate(94.488 663.745)"
          ></path>
          <text
            fill={textHigh}
            data-name="1 x 5 Reps @ RPE7"
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="12"
            fontWeight="700"
            transform="translate(97 508)"
          >
            <tspan x="-52.31" y="0">
              1 x 5 Reps @ RPE7
            </tspan>
          </text>
          <text
            fill={textHigh}
            data-name="3 x 5 Reps @ 142.5 kg (70%)"
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="12"
            fontWeight="700"
            transform="translate(125 588)"
          >
            <tspan x="-79.784" y="0">
              3 x 5 Reps @ 142.5 kg (70%)
            </tspan>
          </text>
          <text
            fill={primaryColor}
            data-name="Actual Results:"
            fontFamily="OpenSans, Open Sans"
            fontSize="10"
            transform="translate(77 539)"
          >
            <tspan x="-33.818" y="0">
              Actual Results:
            </tspan>
          </text>
          <text
            fill={primaryColor}
            data-name="Actual Results:"
            fontFamily="OpenSans, Open Sans"
            fontSize="10"
            transform="translate(77 619)"
          >
            <tspan x="-33.818" y="0">
              Actual Results:
            </tspan>
          </text>
          <circle
            cx="4"
            cy="4"
            r="4"
            fill={primaryColor}
            data-name="Ellipse 88"
            transform="translate(24 500)"
          ></circle>
          <circle
            cx="4"
            cy="4"
            r="4"
            fill={primaryColor}
            data-name="Ellipse 89"
            transform="translate(24 580)"
          ></circle>
          <path
            fill={elevationTwo}
            d="M0 0H320V1H0z"
            data-name="Rectangle 1059"
            transform="translate(24 519)"
          ></path>
          <path
            fill={elevationTwo}
            d="M0 0H320V1H0z"
            data-name="Rectangle 1060"
            transform="translate(24 599)"
          ></path>
          <text
            fill={textLow}
            data-name="1"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(145 561)"
          >
            <tspan x="-3.431" y="0">
              1
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="1"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(145 641)"
          >
            <tspan x="-3.431" y="0">
              1
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="2"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(145 660.404)"
          >
            <tspan x="-3.431" y="0">
              2
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="3"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(145 679.809)"
          >
            <tspan x="-3.431" y="0">
              3
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="5"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(195 561)"
          >
            <tspan x="-3.431" y="0">
              5
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="5"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(195 641)"
          >
            <tspan x="-3.431" y="0">
              5
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="5"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(195 660.404)"
          >
            <tspan x="-3.431" y="0">
              5
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="5"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(195 679.809)"
          >
            <tspan x="-3.431" y="0">
              5
            </tspan>
          </text>
          <text
            fill={textHigh}
            data-name="Reps"
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="12"
            fontWeight="700"
            transform="translate(192 540)"
          >
            <tspan x="-14.285" y="0">
              Reps
            </tspan>
          </text>
          <text
            fill={textHigh}
            data-name="Reps"
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="12"
            fontWeight="700"
            transform="translate(192 620)"
          >
            <tspan x="-14.285" y="0">
              Reps
            </tspan>
          </text>
          <text
            fill={textHigh}
            data-name="#"
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="12"
            fontWeight="700"
            transform="translate(145 540)"
          >
            <tspan x="-3.876" y="0">
              #
            </tspan>
          </text>
          <text
            fill={textHigh}
            data-name="#"
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="12"
            fontWeight="700"
            transform="translate(145 620)"
          >
            <tspan x="-3.876" y="0">
              #
            </tspan>
          </text>
          <text
            fill={textHigh}
            data-name="RPE"
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="12"
            fontWeight="700"
            transform="translate(247 540)"
          >
            <tspan x="-11.089" y="0">
              RPE
            </tspan>
          </text>
          <text
            fill={textHigh}
            data-name="RPE"
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="12"
            fontWeight="700"
            transform="translate(247 620)"
          >
            <tspan x="-11.089" y="0">
              RPE
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="7"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(244 561)"
          >
            <tspan x="-3.431" y="0">
              7
            </tspan>
          </text>
          <text
            fill={textHigh}
            data-name="Load"
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="12"
            fontWeight="700"
            transform="translate(302 540)"
          >
            <tspan x="-14.525" y="0">
              Load
            </tspan>
          </text>
          <text
            fill={textHigh}
            data-name="Load"
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="12"
            fontWeight="700"
            transform="translate(302 620)"
          >
            <tspan x="-14.525" y="0">
              Load
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="160 kg"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(302 561)"
          >
            <tspan x="-18.287" y="0">
              160 kg
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="142.5 kg"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(302 641)"
          >
            <tspan x="-23.314" y="0">
              142.5 kg
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="142.5 kg"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(302 660.404)"
          >
            <tspan x="-23.314" y="0">
              142.5 kg
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="142.5 kg"
            fontFamily="OpenSans, Open Sans"
            fontSize="12"
            transform="translate(302 679.809)"
          >
            <tspan x="-23.314" y="0">
              142.5 kg
            </tspan>
          </text>
          <g data-name="Group 1686" transform="translate(0 45)">
            <path
              fill={textMid}
              d="M12 10a2 2 0 102 2 2 2 0 00-2-2zm-7 0a2 2 0 102 2 2 2 0 00-2-2zm14 0a2 2 0 102 2 2 2 0 00-2-2z"
              data-name="ellipsis-h"
              transform="translate(295 408)"
            ></path>
          </g>
        </g>
        <path
          fill={elevationOne}
          d="M360 0H0v96h360z"
          data-name="Tool bar bg"
        ></path>
        <text
          fill={textHigh}
          fontFamily="OpenSans-Bold, Open Sans"
          fontSize="20"
          fontWeight="700"
          transform="translate(16 67)"
        >
          <tspan x="0" y="0">
            Calendar
          </tspan>
        </text>
        <g data-name="Component 88 – 2" transform="translate(264 44)">
          <g data-name="Group 182" transform="translate(-10 -3)">
            <path
              fill="none"
              d="M0 0H40V32H0z"
              data-name="Base copy 9"
              transform="translate(10 3)"
            ></path>
            <text
              fill={textHigh}
              fontFamily="OpenSans, Open Sans"
              fontSize="12"
              transform="translate(30 24)"
            >
              <tspan x="-18.524" y="0">
                Month
              </tspan>
            </text>
          </g>
          <g data-name="Group 183" transform="translate(34 -3)">
            <path
              fill="none"
              d="M0 0H40V32H0z"
              data-name="Base copy 9"
              transform="translate(6 3)"
            ></path>
            <text
              fill={primaryColor}
              fontFamily="OpenSans, Open Sans"
              fontSize="12"
              transform="translate(26 24)"
            >
              <tspan x="-10.734" y="0">
                Day
              </tspan>
            </text>
          </g>
        </g>
        <text
          fill={primaryColor}
          data-name="February, 2024"
          fontFamily="OpenSans-Semibold, Open Sans"
          fontSize="12"
          fontWeight="600"
          transform="translate(180 117)"
        >
          <tspan x="-42.688" y="0">
            February, 2024
          </tspan>
        </text>
        <g data-name="Group 468" fontSize="12" transform="translate(-7)">
          <text
            fill={textHigh}
            fontFamily="OpenSans-Bold, Open Sans"
            fontWeight="700"
            transform="translate(33 150.518)"
          >
            <tspan x="-10.433" y="0">
              MO
            </tspan>
          </text>
          <text
            fill={textMid}
            data-name="16"
            fontFamily="OpenSans, Open Sans"
            transform="translate(33 178.937)"
          >
            <tspan x="-6.861" y="0">
              16
            </tspan>
          </text>
        </g>
        <g data-name="Group 467" fontSize="12" transform="translate(-10)">
          <text
            fill={textHigh}
            fontFamily="OpenSans-Bold, Open Sans"
            fontWeight="700"
            transform="translate(86 151.023)"
          >
            <tspan x="-8.01" y="0">
              TU
            </tspan>
          </text>
          <text
            fill={textMid}
            data-name="17"
            fontFamily="OpenSans, Open Sans"
            transform="translate(86 179.441)"
          >
            <tspan x="-6.861" y="0">
              17
            </tspan>
          </text>
        </g>
        <g data-name="Group 466" fontSize="12" transform="translate(-11)">
          <text
            fill={textHigh}
            fontFamily="OpenSans-Bold, Open Sans"
            fontWeight="700"
            transform="translate(137 151.023)"
          >
            <tspan x="-9.161" y="0">
              WE
            </tspan>
          </text>
          <text
            fill={textMid}
            data-name="18"
            fontFamily="OpenSans, Open Sans"
            transform="translate(137 179.441)"
          >
            <tspan x="-6.861" y="0">
              18
            </tspan>
          </text>
        </g>
        <g data-name="Group 469" fontSize="12" transform="translate(-3)">
          <text
            fill={textHigh}
            fontFamily="OpenSans-Bold, Open Sans"
            fontWeight="700"
            transform="translate(239 151.023)"
          >
            <tspan x="-7.254" y="0">
              FR
            </tspan>
          </text>
          <text
            fill={textMid}
            data-name="20"
            fontFamily="OpenSans, Open Sans"
            transform="translate(239 179.441)"
          >
            <tspan x="-6.861" y="0">
              20
            </tspan>
          </text>
        </g>
        <g data-name="Group 470" fontSize="12" transform="translate(-2)">
          <text
            fill={textHigh}
            fontFamily="OpenSans-Bold, Open Sans"
            fontWeight="700"
            transform="translate(287 150.023)"
          >
            <tspan x="-7.444" y="0">
              SA
            </tspan>
          </text>
          <text
            fill={textMid}
            data-name="21"
            fontFamily="OpenSans, Open Sans"
            transform="translate(287 179.441)"
          >
            <tspan x="-6.861" y="0">
              21
            </tspan>
          </text>
        </g>
        <g data-name="Group 471" fontSize="12" transform="translate(-1)">
          <text
            fill={textHigh}
            fontFamily="OpenSans-Bold, Open Sans"
            fontWeight="700"
            transform="translate(337 151.023)"
          >
            <tspan x="-7.84" y="0">
              SU
            </tspan>
          </text>
          <text
            fill={textMid}
            data-name="22"
            fontFamily="OpenSans, Open Sans"
            transform="translate(337 179.441)"
          >
            <tspan x="-6.861" y="0">
              22
            </tspan>
          </text>
        </g>
        <text
          fill={textHigh}
          fontFamily="OpenSans-Bold, Open Sans"
          fontSize="12"
          fontWeight="700"
          transform="translate(180 151.023)"
        >
          <tspan x="-8.065" y="0">
            TH
          </tspan>
        </text>
        <g data-name="Group 464" transform="translate(1 -202.868)">
          <circle
            cx="13.092"
            cy="13.092"
            r="13.092"
            fill={primaryColor}
            data-name="Ellipse 790"
            transform="translate(166 364.868)"
          ></circle>
          <text
            fill={textColor}
            data-name="19"
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="12"
            fontWeight="700"
            transform="translate(179 382.868)"
          >
            <tspan x="-6.861" y="0">
              19
            </tspan>
          </text>
        </g>
        <path
          fill={primaryColor}
          d="M11.29 12l3.54-3.54a1 1 0 10-1.42-1.41l-4.24 4.24a1 1 0 000 1.42L13.41 17a1 1 0 101.42-1.41z"
          transform="translate(23.126 100.246)"
        ></path>
        <path
          fill={primaryColor}
          d="M14.83 11.29l-4.24-4.24a1 1 0 00-1.42 1.41L12.71 12l-3.54 3.54a1 1 0 001.42 1.41l4.24-4.24a1 1 0 000-1.42z"
          transform="translate(312.874 100.246)"
        ></path>
        <path
          fill="none"
          stroke={elevationTwo}
          strokeWidth="1"
          d="M360 0L0 0"
          data-name="Line 19"
          transform="translate(0 96)"
        ></path>
        <rect
          width="36"
          height="3"
          fill={textHigh}
          data-name="Rectangle 1056"
          rx="1.5"
          transform="translate(162 203)"
        ></rect>
        <rect
          width="344"
          height="152"
          fill={elevationOne}
          data-name="Rectangle 1057"
          rx="8"
          transform="translate(8 228)"
        ></rect>
        <text
          fill={primaryColor}
          data-name="Weeks 1 - 5"
          fontFamily="OpenSans-Bold, Open Sans"
          fontSize="10"
          fontWeight="700"
          transform="translate(16 253.202)"
        >
          <tspan x="0" y="0">
            Weeks 1 - 5
          </tspan>
        </text>
        <text
          fill={textHigh}
          data-name="Beginner Volume Phase"
          fontFamily="OpenSans, Open Sans"
          fontSize="12"
          transform="translate(16 270.164)"
        >
          <tspan x="0" y="0">
            Beginner Volume Phase
          </tspan>
        </text>
        <path
          fill={textMid}
          d="M12 10a2 2 0 102 2 2 2 0 00-2-2zm-7 0a2 2 0 102 2 2 2 0 00-2-2zm14 0a2 2 0 102 2 2 2 0 00-2-2z"
          data-name="ellipsis-h"
          transform="translate(295 236)"
        ></path>
        <g data-name="Group 473">
          <g filter="url(#MENU_copy_3)">
            <rect
              width="323"
              height="2"
              fill={textLow}
              data-name="MENU copy 3"
              rx="1"
              transform="translate(21 304)"
            ></rect>
          </g>
          <g filter="url(#MENU_copy_4)">
            <rect
              width="220"
              height="2"
              fill={primaryColor}
              data-name="MENU copy 4"
              opacity="0.98"
              rx="1"
              transform="translate(16 304)"
            ></rect>
          </g>
        </g>
        <text
          fill={textLow}
          data-name="Program Progress"
          fontFamily="OpenSans, Open Sans"
          fontSize="10"
          transform="translate(16 295.348)"
        >
          <tspan x="0" y="0">
            Program Progress
          </tspan>
        </text>
        <text
          fill={textHigh}
          data-name="Week 1 Day3"
          fontFamily="OpenSans, Open Sans"
          fontSize="10"
          transform="translate(284 321.486)"
        >
          <tspan x="0" y="0">
            Week 1 Day3
          </tspan>
        </text>
        <circle
          cx="2.5"
          cy="2.5"
          r="2.5"
          fill={primaryColor}
          data-name="Ellipse 95"
          transform="translate(66 367)"
        ></circle>
        <circle
          cx="2.5"
          cy="2.5"
          r="2.5"
          fill={primaryColor}
          data-name="Ellipse 98"
          transform="translate(178 367)"
        ></circle>
        <circle
          cx="2.5"
          cy="2.5"
          r="2.5"
          fill={primaryColor}
          data-name="Ellipse 96"
          transform="translate(123 367)"
        ></circle>
        <circle
          cx="2.5"
          cy="2.5"
          r="2.5"
          fill={primaryColor}
          data-name="Ellipse 97"
          transform="translate(234 367)"
        ></circle>
        <circle
          cx="2.5"
          cy="2.5"
          r="2.5"
          fill={primaryColor}
          data-name="Ellipse 99"
          transform="translate(288 367)"
        ></circle>
        <path
          fill="none"
          d="M0 0h24v24H0z"
          data-name="Path 607"
          transform="translate(105 346)"
        ></path>
        <g data-name="Group 1683">
          <g data-name="Group 1676" transform="translate(31.213 3.818)">
            <path
              fill="none"
              stroke={textHigh}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M47.5 344.472v9.065a2.043 2.043 0 01-1.56 2.009c-1.548.268-17.486 0-17.486 0a1.771 1.771 0 01-1.661-2.009c.05-1.96 0-10.364 0-10.364a1.5 1.5 0 011.661-1.661 18.8 18.8 0 002.164 0 1.636 1.636 0 001.562-1.537 2.15 2.15 0 011.695-1.787h7.512"
              data-name="Path 606"
            ></path>
            <rect
              width="2"
              height="6"
              fill={textHigh}
              data-name="Rectangle 1061"
              rx="1"
              transform="translate(46 335)"
            ></rect>
            <rect
              width="2"
              height="6"
              fill={textHigh}
              data-name="Rectangle 1062"
              rx="1"
              transform="rotate(90 -143.5 193.5)"
            ></rect>
            <g
              fill="none"
              stroke={textHigh}
              strokeWidth="2"
              data-name="Ellipse 90"
              transform="translate(32 342)"
            >
              <circle cx="5" cy="5" r="5" stroke="none"></circle>
              <circle cx="5" cy="5" r="4"></circle>
            </g>
          </g>
          <g
            stroke={textHigh}
            data-name="Group 1675"
            transform="translate(-1452 -42.182)"
          >
            <g
              fill="none"
              strokeWidth="2"
              data-name="Rectangle 1063"
              transform="translate(1566 383)"
            >
              <rect width="22" height="21" stroke="none" rx="3"></rect>
              <rect width="20" height="19" x="1" y="1" rx="2"></rect>
            </g>
            <g
              fill={elevationOne}
              strokeLinecap="round"
              strokeWidth="2"
              data-name="Rectangle 1064"
              transform="translate(1571 380)"
            >
              <rect width="12" height="12" stroke="none" rx="3"></rect>
              <rect
                width="10"
                height="10"
                x="1"
                y="1"
                fill="none"
                rx="2"
              ></rect>
            </g>
            <g
              fill="none"
              strokeWidth="1"
              data-name="Rectangle 1065"
              transform="translate(1574 396)"
            >
              <rect width="6" height="2" stroke="none" rx="1"></rect>
              <rect width="5" height="1" x="0.5" y="0.5" rx="0.5"></rect>
            </g>
            <g
              fill="none"
              strokeWidth="1"
              data-name="Rectangle 1066"
              transform="rotate(-58 1139.119 -1225.444)"
            >
              <rect width="6" height="2" stroke="none" rx="1"></rect>
              <rect width="5" height="1" x="0.5" y="0.5" rx="0.5"></rect>
            </g>
          </g>
          <g data-name="Group 1677" transform="translate(65 3.818)">
            <rect
              width="2"
              height="6"
              fill={textHigh}
              data-name="Rectangle 1068"
              rx="1"
              transform="translate(115 343)"
            ></rect>
            <rect
              width="2"
              height="6"
              fill={textHigh}
              data-name="Rectangle 1067"
              rx="1"
              transform="rotate(90 -113 232)"
            ></rect>
            <g
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              data-name="Path 608"
            >
              <path
                d="M14 4.835a7.2 7.2 0 0110.175 10.157L14 25.182 3.825 14.992A7.2 7.2 0 0114 4.835z"
                transform="translate(102 333)"
              ></path>
              <path
                fill={textHigh}
                d="M9.2 5a5.202 5.202 0 00-3.916 8.621l8.715 8.73 8.718-8.73c1.796-2.051 1.694-5.16-.24-7.1a5.154 5.154 0 00-3.674-1.52c-1.285 0-2.516.469-3.466 1.322a2 2 0 01-2.67.001A5.185 5.185 0 009.198 5m0-2c1.72 0 3.438.612 4.802 1.835 2.819-2.531 7.175-2.447 9.89.273a7.201 7.201 0 01.284 9.884l-10.176 10.19-10.174-10.19A7.202 7.202 0 019.2 3z"
                transform="translate(102 333)"
              ></path>
            </g>
          </g>
          <g data-name="Group 1678" transform="translate(-1456.074 -40.277)">
            <path
              fill="none"
              stroke={textHigh}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M1736.074 381.898v20.374h20.374"
              data-name="Path 609"
            ></path>
            <path
              fill="none"
              stroke={textHigh}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              d="M1741.369 394.139l5.49-5 3.432 3.922 6.275-5.981"
              data-name="Path 610"
            ></path>
            <circle
              cx="1.5"
              cy="1.5"
              r="1.5"
              fill={textHigh}
              data-name="Ellipse 91"
              transform="translate(1745 388)"
            ></circle>
            <circle
              cx="1.5"
              cy="1.5"
              r="1.5"
              fill={textHigh}
              data-name="Ellipse 92"
              transform="translate(1749 391)"
            ></circle>
            <circle
              cx="1.5"
              cy="1.5"
              r="1.5"
              fill={textHigh}
              data-name="Ellipse 93"
              transform="translate(1755 386)"
            ></circle>
            <circle
              cx="1.5"
              cy="1.5"
              r="1.5"
              fill={textHigh}
              data-name="Ellipse 94"
              transform="translate(1740 392)"
            ></circle>
          </g>
          <g data-name="Group 1682" transform="translate(-1477.078 -42.182)">
            <g data-name="Group 1680" transform="translate(1703.078 382.003)">
              <path
                fill="rgba(0,0,0,0)"
                d="M0 0h20.754v20.754H0z"
                data-name="Path 611"
              ></path>
              <path
                fill="none"
                stroke={textHigh}
                strokeWidth="2"
                d="M10.052 6.245c-.758 0-1.93-.861-3.165-.83a4.673 4.673 0 00-3.964 2.407c-1.691 2.937-.436 7.274 1.214 9.661.809 1.162 1.764 2.47 3.03 2.428 1.214-.052 1.671-.789 3.144-.789s1.878.789 3.165.758c1.307-.021 2.138-1.183 2.937-2.356a10.429 10.429 0 001.328-2.729 8.317 8.317 0 00.676-3.994 5.832 5.832 0 00-1.175-3.529 4.492 4.492 0 00-3.507-1.9c-1.6-.125-2.937.872-3.684.872z"
                data-name="Path 612"
              ></path>
            </g>
            <path
              fill={textHigh}
              d="M14.753 4.4A4.864 4.864 0 0015.908.85a5 5 0 00-3.272 1.684 4.652 4.652 0 00-1.179 3.441 4.148 4.148 0 003.3-1.576z"
              data-name="Path 614"
              transform="translate(1702.027 380)"
            ></path>
          </g>
        </g>
        <g data-name="Group 3288" transform="translate(-4160 -804)">
          <g filter="url(#Rectangle_903)" transform="translate(4160 804)">
            <path
              fill={bgColor}
              d="M0 0H360V80H0z"
              data-name="Rectangle 903"
              transform="translate(0 680)"
            ></path>
          </g>
          <g transform="translate(4472.034 1512.625)">
            <path
              fill={textLow}
              d="M18.428 14.844a7.2 7.2 0 10-8.9 0 11.992 11.992 0 00-7.459 9.809 1.206 1.206 0 002.4.264 9.593 9.593 0 0119.067 0 1.2 1.2 0 001.2 1.067h.132a1.2 1.2 0 001.055-1.319 11.992 11.992 0 00-7.495-9.821zm-4.449-.851a4.8 4.8 0 114.8-4.8 4.8 4.8 0 01-4.8 4.8z"
              transform="translate(-2.064 -1.995)"
            ></path>
          </g>
          <g transform="translate(4400.026 1512.625)">
            <path
              fill={textLow}
              d="M14 6.8A1.2 1.2 0 0012.8 8v12a1.2 1.2 0 002.4 0V8A1.2 1.2 0 0014 6.8zM8 14a1.2 1.2 0 00-1.2 1.2V20a1.2 1.2 0 002.4 0v-4.8A1.2 1.2 0 008 14zm12-2.4a1.2 1.2 0 00-1.2 1.2V20a1.2 1.2 0 002.4 0v-7.2a1.2 1.2 0 00-1.2-1.2zM22.4 2H5.6A3.6 3.6 0 002 5.6v16.8A3.6 3.6 0 005.6 26h16.8a3.6 3.6 0 003.6-3.6V5.6A3.6 3.6 0 0022.4 2zm1.2 20.4a1.2 1.2 0 01-1.2 1.2H5.6a1.2 1.2 0 01-1.2-1.2V5.6a1.2 1.2 0 011.2-1.2h16.8a1.2 1.2 0 011.2 1.2z"
              transform="translate(-2 -2)"
            ></path>
          </g>
          <g transform="translate(4253.092 1512.625)">
            <path
              fill={textLow}
              d="M12.908 20.634a1.091 1.091 0 10-1.091-1.091 1.091 1.091 0 001.091 1.091zm5.454 0a1.091 1.091 0 10-1.091-1.091 1.091 1.091 0 001.091 1.091zm0-4.363a1.091 1.091 0 10-1.091-1.091 1.091 1.091 0 001.091 1.091zm-5.454 0a1.091 1.091 0 10-1.091-1.091 1.091 1.091 0 001.091 1.091zm7.636-13.09h-1.091v-1.09a1.091 1.091 0 00-2.182 0v1.091H8.545V2.091a1.091 1.091 0 00-2.182 0v1.091H5.272A3.272 3.272 0 002 6.454v15.271A3.272 3.272 0 005.272 25h15.272a3.272 3.272 0 003.272-3.272V6.454a3.272 3.272 0 00-3.272-3.272zm1.091 18.544a1.091 1.091 0 01-1.091 1.091H5.272a1.091 1.091 0 01-1.091-1.091v-9.817h17.453zm0-12H4.182V6.454a1.091 1.091 0 011.09-1.091h1.091v1.091a1.091 1.091 0 002.182 0V5.363h8.726v1.091a1.091 1.091 0 002.182 0V5.363h1.091a1.091 1.091 0 011.091 1.091zM7.454 16.271a1.091 1.091 0 10-1.091-1.091 1.091 1.091 0 001.091 1.091zm0 4.363a1.091 1.091 0 10-1.091-1.091 1.091 1.091 0 001.091 1.091z"
              transform="translate(-2 -1)"
            ></path>
          </g>
          <ellipse
            cx="20"
            cy="20.5"
            fill={primaryColor}
            data-name="Ellipse 70"
            rx="20"
            ry="20.5"
            transform="translate(4320 1504)"
          ></ellipse>
          <rect
            width="2"
            height="16"
            fill={textColor}
            data-name="Rectangle 904"
            rx="1"
            transform="translate(4339 1517)"
          ></rect>
          <rect
            width="2"
            height="16"
            fill={textColor}
            data-name="Rectangle 905"
            rx="1"
            transform="rotate(90 1412 2936)"
          ></rect>
          <path
            fill={primaryColor}
            stroke="rgba(0,0,0,0)"
            strokeMiterlimit="10"
            strokeWidth="1"
            d="M4205.374 1519.849h0l-7.191-6.3a3.6 3.6 0 00-4.794 0l-7.189 6.3a3.6 3.6 0 00-1.2 2.7v10.478a3.6 3.6 0 003.6 3.6h14.377a3.6 3.6 0 003.6-3.6v-10.486a3.6 3.6 0 00-1.2-2.7zm-7.191 14.377h-4.794v-5.992a1.2 1.2 0 011.2-1.2h2.4a1.2 1.2 0 011.2 1.2zm5.992-1.2a1.2 1.2 0 01-1.2 1.2h-2.4v-5.992a3.6 3.6 0 00-3.6-3.6h-2.4a3.6 3.6 0 00-3.6 3.6v5.992h-2.375a1.2 1.2 0 01-1.2-1.2v-10.485a1.2 1.2 0 01.407-.9l7.193-6.292a1.2 1.2 0 011.582 0l7.191 6.292a1.2 1.2 0 01.407.9z"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default MobileCalendarPreview;
